import template from './index.jst';
import './index.styl';
import { StatsItem } from '../../index';
import VenuesStatsHeading from './VenuesStatsHeading';
import VenuesStatsTable from './VenuesStatsTable';

export class VenuesStats extends StatsItem {
	get template() {
		return template;
	}

	get className() {
		return 'match-stats';
	}

	regions() {
		return {
			'venues_stats_header': '.venues-stats-header',
			'venues_stats_table': '.venues-stats-table'
		};
	}

	initialize() {
		this.getRegion('venues_stats_header').show(new VenuesStatsHeading(this.options));
		this.getRegion('venues_stats_table').show(new VenuesStatsTable(this.options));
	}
}
export default VenuesStats;